


























import { defineComponent, ref } from "@vue/composition-api";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import CsvCustomizeModal from "@/components/Organisms/CsvCustomizeModal/index.vue";
import ConfirmModal from "@/components/Organisms/modals/ConfirmModal/index.vue";
import { postVideoBundleUnlockingLogsCsvDownloadRequests } from "@/api";

interface CsvColumn {
  name:
    | "unlocked_at"
    | "unique_id"
    | "name"
    | "name_kana"
    | "university_name"
    | "department_name"
    | "email"
    | "internship_results"
    | "high_school"
    | "activities"
    | "tel"
    | "unofficial_offer_results"
    | "full_address"
    | "date_of_birth"
    | "grade"
    | "graduate_year"
    | "concentration_name"
    | "seminar_circle"
    | "course"
    | "languages"
    | "video_bundle_title"
    | "video_chapter_title"
    | "self_promotion"
    | "student_endeavor";
  label: string;
}

const availableCsvColumns: CsvColumn[] = [
  { name: "unlocked_at", label: "エントリー日時" },
  { name: "unique_id", label: "識別コード" },
  { name: "name", label: "名前" },
  { name: "name_kana", label: "名前（カナ）" },
  { name: "university_name", label: "大学" },
  { name: "department_name", label: "学部" },
  { name: "email", label: "大学メールアドレス" },
  { name: "internship_results", label: "インターン実績" },
  { name: "high_school", label: "出身高校名" },
  { name: "activities", label: "学生時代の活動実績" },
  { name: "tel", label: "電話番号" },
  { name: "unofficial_offer_results", label: "内定実績" },
  { name: "full_address", label: "住所" },
  { name: "date_of_birth", label: "生年月日" },
  { name: "grade", label: "学年" },
  { name: "graduate_year", label: "卒業年度" },
  { name: "concentration_name", label: "学科" },
  { name: "seminar_circle", label: "ゼミ・研究室" },
  { name: "course", label: "文理" },
  { name: "languages", label: "言語レベル" },
  { name: "video_bundle_title", label: "エントリー動画" },
  { name: "video_chapter_title", label: "エントリーチャプター" },
  { name: "self_promotion", label: "自己PR" },
  { name: "student_endeavor", label: "学生時代に頑張ったこと" }
];

export default defineComponent({
  name: "VideoBundleUnlockingLogsCSVDownloadButton",
  components: {
    OccButton,
    CsvCustomizeModal,
    ConfirmModal
  },
  props: {
    searchParams: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const isCustomizeModalShow = ref(false);
    const isConfirmModalShow = ref(false);

    const includedColumns = ref<CsvColumn[]>([]);
    const excludedColumns = ref<CsvColumn[]>(availableCsvColumns);

    const onClickCsvDownload = () => {
      isCustomizeModalShow.value = true;
    };

    const onCustomizeModalClose = () => {
      isCustomizeModalShow.value = false;
    };

    const onCustomizeModalApply = async () => {
      await postVideoBundleUnlockingLogsCsvDownloadRequests({
        ...(props.searchParams as object),
        columns: includedColumns.value.map(column => column.name)
      });

      // CustomizeModalは元々の処理で勝手に閉じてくれる。
      // ここでは次のモーダルを表示するだけでよい。
      isConfirmModalShow.value = true;
    };

    const onConfirmModalClose = () => {
      isConfirmModalShow.value = false;
    };

    const updateIncludedColumns = (columns: CsvColumn[]) => {
      includedColumns.value = columns;
    };

    const updateExcludedColumns = (columns: CsvColumn[]) => {
      excludedColumns.value = columns;
    };

    return {
      isCustomizeModalShow,
      isConfirmModalShow,
      includedColumns,
      excludedColumns,
      onClickCsvDownload,
      onCustomizeModalClose,
      onCustomizeModalApply,
      onConfirmModalClose,
      updateIncludedColumns,
      updateExcludedColumns
    };
  }
});
